import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';

export class HeadlineNumber extends Component {

    formatCurrency(value) {
        var v = Math.floor(value);
        return Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(v);
    }

    render() {
        return (
            <Card>
                <CardBody className={'headline-number ' + this.props.styleName}>
                    <div className='title'>{this.props.title}</div>
                    <div className='number'>
                        {this.props.valuePounds ? this.formatCurrency(this.props.valuePounds) : '' }
                        {this.props.value}
                    </div>
                    <div className='description'>{this.props.description}</div>
                </CardBody>
            </Card>
            )
    }
}

 


// WEBPACK FOOTER //
// ./src/components/UI/HeadlineNumber.jsx